import { defineStore } from 'pinia'

export const Del_Documents = defineStore({
    id: 'wp_docs__deleted',
    state: () => {
        return { value: [] }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
